import { Model as BaseModel } from 'vue-api-query'
import env from '@/services/env'

export default class Model extends BaseModel {
  baseURL() {
    return env.apiUrl
  }

  // implement a default request method
  request(config) {
    return this.$http.request(config)
  }

  moneyFormat(value, currency = 'USD') {
    const formatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency,
    })

    return formatter.format(value)
  }
}
